export const listBetweenStamps = (dispatch, apiClient, from, to) => {
  dispatch({ type: 'BOXSTATS_PENDING' });
  return apiClient
    .call({
      endpoint: 'stats/listBetweenStamps',
      data: { from, to }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      dispatch({ type: 'BOXSTATS_BETWEENSTAMP', list: res.data, from, to });
      return res;
    })
    .catch(e => {
      dispatch({ type: 'BOXSTATS_PENDING', pending: false });
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't get box stats",
        snackType: 'warning'
      });
      throw e;
    });
};

export const listWorkBetweenStamps = (dispatch, apiClient, from, to) => {
  return apiClient
    .call({
      endpoint: 'stats/listWorkBetweenStamps',
      data: { from, to }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      return res;
    })
    .catch(e => {
      dispatch({
        type: 'SNACKBAR_SHOW_MSG',
        msg: "Can't get box stats",
        snackType: 'warning'
      });
      throw e;
    });
};

export const productionQueue = (apiClient, locationIds, skipInventory, tabNames) => {
  return apiClient.call({ endpoint: 'stats/productionQueue', data: { locationIds, skipInventory, tabNames } })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      return res;
    });
};

export const productionQueueDistributor = (apiClient) => {
  return apiClient.call({ endpoint: 'stats/productionQueueDistributor' })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      return res;
    });
};

export const misspickStats = (apiClient, from, to) => {
  return apiClient.call({ endpoint: 'stats/misspickStats', data: { from, to } })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      return res;
    });
};

export const misspickWorkStats = (apiClient, from, to) => {
  return apiClient.call({ endpoint: 'stats/misspickWorkStats', data: { from, to } })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      return res;
    });
};

export const shippedStats = (apiClient, from, to, orderStatus) => {
  return apiClient.call({ endpoint: 'stats/shippedStats', data: { from, to, orderStatus } })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      return res;
    });
};
export const pickQaStats = (apiClient, from, to, orderStatus) => {
  return apiClient.call({ endpoint: 'stats/pickQaStats', data: { from, to, orderStatus } })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      return res;
    });
};



// WEBPACK FOOTER //
// ./app/actions/boxStats.js